var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isAuthorized
    ? _c("li", { staticClass: "promo-menu__item" }, [
        _c(
          "a",
          { staticClass: "promo-menu__link", attrs: { href: _vm.link } },
          [
            _c("icon", {
              staticClass: "promo-menu__icon _green",
              attrs: {
                name: "My_recommendations_16",
                role: "img",
                width: 16,
                height: 16
              }
            }),
            _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }